import Label from "../../../ui/components/Label/Label";

import useArtifactProductionStatus from "../../hooks/useArtifactProductionStatus";

export default function ArtifactProductionStatusLabel({ artifact, ...props }) {
	const { text, color } = useArtifactProductionStatus({ artifact });

	return (
		<Label color={color} {...props}>
			{text}
		</Label>
	);
}
